'use strict';

var _ = require('lodash');
var AdvancedHepGridActionsService = function AdvancedHepGridActionsService(restangular, advancedHepPayloadService, advancedHepGridService, fileSaveService, $q) {
  var updateBulkHepService = restangular.service('configuration').one('hep').one('bulk');
  var deleteHepService = restangular.service('configuration').one('hep').one('key');
  var deleteBulkHepService = restangular.service('configuration').one('hep').one('keys');
  var hepTypeVsLabels = {
    'FOAnalystPosMapping': 'FOPOSAssignment',
    'FOCabinClassConfig': 'FOCabinClassDefinition',
    'FOViaPoints': 'FOTotalFareHubDefinition',
    'FOTacticalUserOverrides': 'FOTacticalUserAdjustment',
    'FONoticePeriod': 'FOFilingNoticePeriod',
    'FORBDLevelFareThreshold': 'FOFareClassThreshold',
    'FOTacticalFareIndex': 'FOTacticalFareClassIndex',
    'FOTacticalFBCPatternConfig': 'FOTacticalFBCPatternGeneration',
    'FOUpSellBuyDownConfig': 'FOFareUpsellAndBuydownRestriction',
    'FOTaxOverride': 'FOTotalFareOverride'
  };
  function deleteFromServer(payloads, type) {
    var service = type === 'DA_RIAWeights' ? deleteBulkHepService : deleteHepService;
    return _.map(payloads, function (payload) {
      return service.remove(payload);
    });
  }
  function isHepWithNoHierarchy(type) {
    var notHierarchyTypes = ['FlightExclusion', 'FOMarketList', 'FOFareBrandDefinitionConfig', 'FOFareBasisCodePattern', 'FOUpSellBuyDownConfig', 'FOTacticalUserOverrides'];
    return _.includes(notHierarchyTypes, type);
  }
  function remove(rows, type, level) {
    var payloads = advancedHepPayloadService.buildRemovePayloads(rows, type, level);
    return $q.all(deleteFromServer(payloads, type));
  }
  function saveToServer(payloads) {
    var payload = {
      value: payloads
    };
    return updateBulkHepService.customPUT(payload, undefined, {
      upsert: true
    });
  }
  function save(rows, type, level) {
    var payloads = advancedHepPayloadService.buildSavePayloads(rows, type, level);
    var promises = [];
    if (payloads.updatePayloads && payloads.updatePayloads.length) {
      promises.push(saveToServer(payloads.updatePayloads));
    }
    if (payloads.deletePayloads && payloads.deletePayloads.length) {
      promises = promises.concat(deleteFromServer(payloads.deletePayloads));
    }
    return $q.all(promises);
  }
  function exportToCsv(data, type) {
    var exportColumnsOrder = advancedHepGridService.getCsvExportOrder(type);
    var exportFunction = advancedHepGridService.getExportDataFunction(type);
    var fileData = exportFunction(_.cloneDeep(data), exportColumnsOrder);
    var filename = getFileNameForExport(type);
    fileSaveService.createFile(fileData, 'text/csv', filename + '.csv');
  }
  function getFileNameForExport(type) {
    return hepTypeVsLabels.hasOwnProperty(type) ? hepTypeVsLabels[type] : type;
  }
  return {
    remove: remove,
    save: save,
    exportToCsv: exportToCsv,
    isHepWithNoHierarchy: isHepWithNoHierarchy
  };
};
AdvancedHepGridActionsService.$inject = ['Restangular', 'AdvancedHepPayloadService', 'AdvancedHepGridService', 'FileSaveService', '$q'];
module.exports = AdvancedHepGridActionsService;